export const KAIJA_2027_LITTER = 'Kaija 2027';

export type PlannedLitter = {
    id: string;
    name: string;
    timing: string;
};

export const PLANNED_LITTERS: PlannedLitter[] = [
    {
        id: 'kaija-2027',
        name: KAIJA_2027_LITTER,
        timing: 'Expected Spring 2027',
    },
];

export const normalizeLitterName = (value: string): string => value.trim().toLowerCase();
